/* REVERT clearCollectionHeroInlineBg 202609231648 — page freeze from style MutationObserver */
/* FH speed phase 1 2026-10-09: same fixes, run less often. The main page watcher now waits until the page has
 * been quiet for 120 ms (and the browser is idle, at most 0.3 s more) before re-running the fixes, ignores script/style-only changes,
 * and the extra re-runs are cut from six to two. Link addresses are cached. Filter-only watchers start only on
 * collection/search pages (or once filter markup appears). No fix was added, removed or changed. Rollback: restore the
 * previous version of this file from the theme 'Journal card corners 2026-10-08'. */
/**
 * DRAFT-ONLY early hook: allow Qikify tmenu on unpublished preview.
 * Must run before smartmenu-v2.js (both are defer; this asset is earlier in DOM).
 */
(function () {
  try {
    var DRAFT_THEME_ID = 189250502936;
    if (!window.Shopify || !Shopify.theme) return;
    if (Shopify.theme.id !== DRAFT_THEME_ID) return;
    if (Shopify.theme.role !== 'unpublished') return;
    Object.defineProperty(Shopify.theme, 'role', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: 'main'
    });
    window.__FH_ADA_TMENU_ROLE_SPOOF__ = true;
  } catch (e) {}
})();

/**
 * Fab Habitat — WCAG 2.1 AA quick-win JS fixes (Critical + High)
 * Draft only — NOT live. Include from layout/theme.liquid before </body>:
 *   <script src="{{ 'ada-a11y-fixes.js' | asset_url }}" defer></script>
 * Safe to re-run; uses MutationObserver for late app widgets (Gowl, Globo, Fether).
 * Date: 2026-09-21
 */
(function () {
  'use strict';

  function setIfEmpty(el, attr, value) {
    if (!el) return;
    var cur = el.getAttribute(attr);
    if (!cur || !String(cur).trim()) el.setAttribute(attr, value);
  }

  /* A. PDP / sitewide carousel buttons — Slick + Gowl */
  function labelCarouselButtons(root) {
    root = root || document;
    root.querySelectorAll('.slider-button--prev, button.slick-prev').forEach(function (btn) {
      setIfEmpty(btn, 'aria-label', 'Previous slide');
      btn.removeAttribute('role'); // never presentation on a real button
    });
    root.querySelectorAll('.slider-button--next, button.slick-next').forEach(function (btn) {
      setIfEmpty(btn, 'aria-label', 'Next slide');
      btn.removeAttribute('role');
    });
    root.querySelectorAll('.gowl-prev, button.gowl-prev').forEach(function (btn) {
      setIfEmpty(btn, 'aria-label', 'Previous related products');
      if (btn.getAttribute('role') === 'presentation') btn.removeAttribute('role');
    });
    root.querySelectorAll('.gowl-next, button.gowl-next').forEach(function (btn) {
      setIfEmpty(btn, 'aria-label', 'Next related products');
      if (btn.getAttribute('role') === 'presentation') btn.removeAttribute('role');
    });
  }

  /* B. Feature icons — decorative when caption text is visible (WAVE-08)
   * Prior pass copied caption into alt → WAVE "Redundant alternative text" ×8
   * on PDP "Why we love this rug" .each_icon_holder icons. Visible <p> is the
   * accessible name; icon imgs must be alt="" + aria-hidden.
   */
  function fixFeatureIconAlts(root) {
    root = root || document;
    root.querySelectorAll('.each_icon_holder').forEach(function (holder) {
      var img = holder.querySelector('img');
      if (!img) return;
      var caption = holder.querySelector('p');
      var text = caption ? (caption.textContent || '').trim() : '';
      if (text) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('data-ada-wave08', 'decorative');
      } else if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('data-ada-wave08', 'decorative');
      }
    });
  }

  /* C. Logo home link accessible name; demote logo h1 off home */
  function fixLogoLink() {
    var link = document.querySelector('a.header__heading-link');
    if (link) setIfEmpty(link, 'aria-label', 'Fab Habitat home');

    var svg = document.querySelector('.header__heading-link svg');
    if (svg && !svg.querySelector('title')) {
      var title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
      title.textContent = 'Fab Habitat';
      svg.insertBefore(title, svg.firstChild);
    }

    // Demote logo <h1> on non-index templates so page title can be unique H1
    var isHome =
      document.body.classList.contains('template-index') ||
      (window.Shopify && Shopify.theme && false) ||
      (document.body.id === 'index') ||
      /^\/?$/.test(location.pathname);
    // Prefer Shopify template class if present
    if (document.body.className.indexOf('template-') !== -1) {
      isHome = document.body.classList.contains('template-index');
    }
    if (!isHome) {
      var h1 = document.querySelector('h1.header__heading');
      if (h1) {
        var div = document.createElement('div');
        div.className = h1.className;
        while (h1.firstChild) div.appendChild(h1.firstChild);
        h1.parentNode.replaceChild(div, h1);
      }
    }
  }

  /* G. Related / Gowl image-only product links */
  function nameRelatedProductLinks(root) {
    root = root || document;
    root.querySelectorAll('.gowl-item a[href*="/products/"], .ga-product a[href*="/products/"]').forEach(function (a) {
      if ((a.textContent || '').trim()) return;
      if (a.getAttribute('aria-label')) return;
      var card = a.closest('.gowl-item, .ga-product') || a.parentElement;
      var titleEl = card && card.querySelector('.ga-product_title, .gowl-item__title, a.ga-product_title');
      var title = titleEl ? (titleEl.textContent || '').trim() : '';
      if (!title) {
        var href = a.getAttribute('href') || '';
        var handle = href.split('/products/')[1] || '';
        handle = handle.split('?')[0].replace(/[-_]+/g, ' ');
        title = handle || 'View product';
      }
      a.setAttribute('aria-label', title);
    });
  }

  /* H. Globo price sliders — Broken ARIA harden (WAVE Outdoor Rugs P0 remap-always 2026-09-23)
   * Globo filter CDN sets aria-labelledby="min-label-{id}" / "max-label-{id}" on
   * .noUi-handle* after noUiSlider.create, but this shop's range markup only has
   * inputs id="min-{id}" / "max-{id}" (no min-label-/max-label- nodes).
   * Strategy (remap-always):
   *   1) ALWAYS prefer remapping min-label-{n}→min-{n} / max-label-{n}→max-{n}
   *      when those targets exist (overwrite; never leave min-label-* if min-* exists).
   *   2) If min-{n}/max-{n} missing too: create sr-only span with the EXACT id from
   *      the broken aria-labelledby on the handle itself (do not require finding the
   *      input first — avoids race before gf-range inputs exist).
   *   3) MutationObserver + retries [0,500,1500,3000,5000,8000] ms.
   */
  var __adaGloboAriaFixing = false;

  /** Create sr-only node for a missing labelledby id (parsed from the handle attr). */
  function ensureLabelTargetFromAttrId(labelId, fallbackText) {
    if (!labelId || document.getElementById(labelId)) return;
    var lab = document.createElement('span');
    lab.id = labelId;
    lab.className = 'sr-only ada-globo-range-label';
    lab.setAttribute('aria-hidden', 'false');
    var mm = /^(min|max)-label-(\d+)$/.exec(labelId);
    var text = fallbackText;
    if (!text && mm) {
      text = mm[1] === 'min' ? 'Minimum price' : 'Maximum price';
    }
    lab.textContent = (text || 'Price').trim() || 'Price';
    // Prefer inserting near matching range input if present; else body.
    var n = mm ? mm[2] : null;
    var inp = null;
    if (n) {
      inp = document.getElementById(mm[1] + '-' + n) ||
            document.querySelector('input.gf-range-' + mm[1] + '[id$="-' + n + '"]');
    }
    if (inp && inp.parentNode) inp.parentNode.insertBefore(lab, inp);
    else (document.body || document.documentElement).appendChild(lab);
  }

  /**
   * Remap-always Globo labelledby refs on an element.
   * Prefer real min-{n}/max-{n}; else materialize the broken id as sr-only.
   */
  function remapGloboLabelledbyAlways(el, fallbackLabel) {
    if (!el) return;
    ['aria-labelledby', 'aria-describedby'].forEach(function (attr) {
      var val = el.getAttribute(attr);
      if (!val || !String(val).trim()) return;
      var refs = String(val).trim().split(/\s+/);
      var next = [];
      var changed = false;
      refs.forEach(function (id) {
        if (!id) return;
        var mm = /^(min|max)-label-(\d+)$/.exec(id);
        if (mm) {
          var alt = mm[1] + '-' + mm[2];
          // ALWAYS prefer real min-/max- when it exists (overwrite min-label-*)
          if (document.getElementById(alt)) {
            next.push(alt);
            if (alt !== id) changed = true;
            return;
          }
          // min-/max- missing: create sr-only with EXACT broken id from the attr
          ensureLabelTargetFromAttrId(id, fallbackLabel || (mm[1] === 'min' ? 'Minimum price' : 'Maximum price'));
          next.push(id);
          return;
        }
        // Non-Globo refs: keep if present, else drop
        if (document.getElementById(id)) {
          next.push(id);
        } else {
          changed = true;
        }
      });
      if (!next.length) {
        el.removeAttribute(attr);
      } else if (changed || next.join(' ') !== refs.join(' ')) {
        el.setAttribute(attr, next.join(' '));
      }
    });
    // Other ARIA id-refs: strip if missing (no Globo remap)
    ['aria-controls', 'aria-owns', 'aria-activedescendant'].forEach(function (attr) {
      var val = el.getAttribute(attr);
      if (!val || !String(val).trim()) return;
      var refs = String(val).trim().split(/\s+/);
      var next = refs.filter(function (id) { return id && document.getElementById(id); });
      if (!next.length) el.removeAttribute(attr);
      else if (next.join(' ') !== refs.join(' ')) el.setAttribute(attr, next.join(' '));
    });
  }

  function remapOrStripAriaIdRefs(el) {
    remapGloboLabelledbyAlways(el, null);
  }

  function stripBrokenAriaIdRefs(el) {
    remapOrStripAriaIdRefs(el);
  }

  function fixOneGloboHandle(h, fallbackLabel) {
    if (!h) return;
    setIfEmpty(h, 'aria-label', fallbackLabel);
    remapGloboLabelledbyAlways(h, fallbackLabel);
  }

  function nameGloboSliders(root) {
    if (__adaGloboAriaFixing) return;
    __adaGloboAriaFixing = true;
    try {
      root = root || document;
      // Handles first — parse broken labelledby from the handle attr itself
      // (does not require gf-range inputs to exist yet).
      root.querySelectorAll('.noUi-handle-lower, .noUi-handle[data-handle="0"]').forEach(function (h) {
        fixOneGloboHandle(h, 'Minimum price');
      });
      root.querySelectorAll('.noUi-handle-upper, .noUi-handle[data-handle="1"]').forEach(function (h) {
        fixOneGloboHandle(h, 'Maximum price');
      });
      // Also heal range inputs if Globo stamped broken labelledby on them
      root.querySelectorAll('input.gf-range-min, input.gf-range-max, input[id^="min-"], input[id^="max-"]').forEach(function (inp) {
        var fb = (inp.id || '').indexOf('max-') === 0 ? 'Maximum price' : 'Minimum price';
        remapGloboLabelledbyAlways(inp, fb);
      });
    } finally {
      __adaGloboAriaFixing = false;
    }
  }

  function observeGloboSliderAria() {
    if (window.__adaGloboSliderObs) return;
    var schedule = null;
    function kick() {
      if (schedule) return;
      schedule = setTimeout(function () {
        schedule = null;
        nameGloboSliders(document);
      }, 0);
    }
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          var t = m.target;
          if (!t || !t.classList) continue;
          if (t.classList.contains('noUi-handle') || t.classList.contains('gf-range-min') || t.classList.contains('gf-range-max')) {
            kick();
            return;
          }
        }
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if ((n.classList && (n.classList.contains('noUi-handle') || n.classList.contains('noUi-target') || n.id === 'gf-tree' || (n.className && String(n.className).indexOf('gf-') !== -1))) ||
                (n.querySelector && n.querySelector('.noUi-handle, input.gf-range-min, input.gf-range-max'))) {
              kick();
              return;
            }
          }
        }
      }
    });
    var roots = [document.documentElement];
    var drawer = document.querySelector('#gf-tree, .gf-filter, .gf-left-nav, [class*="spf-search"], .gf-option-block');
    if (drawer) roots.push(drawer);
    roots.forEach(function (r) {
      try {
        obs.observe(r, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'aria-activedescendant']
        });
      } catch (e) {}
    });
    window.__adaGloboSliderObs = obs;
  }

  /* P. Globo price filter — keyboard focus restore + polite announce (2026-09-23)
   * Smoke P1: after Min/Max or noUi handle change, Globo getFilterData("all") replaces
   * #gf-tree via innerHTML → focused node destroyed → focus resets to <body>.
   * Strategy:
   *   1) On focus/change/keydown of gf-range inputs or .noUi-handle, remember which
   *      control (min / max / handle-lower / handle-upper) + input caret when feasible.
   *   2) After globoFilterTreeRenderCompleted / globoFilterRenderCompleted and delayed
   *      retries [0,50,150,350,700] ms, re-focus the equivalent control with
   *      preventScroll; restore selection on inputs when possible.
   *   3) Optional throttled polite aria-live: "Price filter updated: min … max …".
   * Does NOT rewrite Globo Price facet / hide mismatch cards (API returns products
   * whose cheapest displayed variant can be below Min — Globo product-level match).
   * Does NOT touch Featured sort / Block M, Block L, Block N, or fixGloboBisFormLabels.
   * Extends alongside Block H (nameGloboSliders); does not change remap logic.
   * Reversible: delete this block + its boot() call + CSS Block P.
   */
  var __adaGloboPriceFocus = null;
  var __adaGloboPriceRestoreTimer = null;
  var __adaGloboPriceAnnounceTimer = null;

  function adaGloboPriceLiveRegion() {
    var el = document.getElementById('ada-globo-price-live');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'ada-globo-price-live';
    el.className = 'sr-only ada-visually-hidden-focusable';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    el.setAttribute('role', 'status');
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  function adaCaptureGloboPriceFocus(el) {
    if (!el || !el.closest) return;
    if (!el.closest('#gf-tree, .gf-filter, .gf-option-block, .gf-range-inputs, .gf-range-slider, .noUi-target')) return;
    var kind = null;
    var filterId = null;
    if (el.matches && (el.matches('input.gf-range-min') || (el.id && el.id.indexOf('min-') === 0))) {
      kind = 'min';
      filterId = (el.id || '').replace(/^min-/, '') || null;
    } else if (el.matches && (el.matches('input.gf-range-max') || (el.id && el.id.indexOf('max-') === 0))) {
      kind = 'max';
      filterId = (el.id || '').replace(/^max-/, '') || null;
    } else if (el.classList && (el.classList.contains('noUi-handle-lower') || el.getAttribute('data-handle') === '0')) {
      kind = 'handle-lower';
      var sl0 = el.closest('.gf-range-slider, .noUi-target');
      filterId = sl0 && (sl0.getAttribute('data-id') || (sl0.id || '').replace(/^slider-/, '')) || null;
    } else if (el.classList && (el.classList.contains('noUi-handle-upper') || el.getAttribute('data-handle') === '1')) {
      kind = 'handle-upper';
      var sl1 = el.closest('.gf-range-slider, .noUi-target');
      filterId = sl1 && (sl1.getAttribute('data-id') || (sl1.id || '').replace(/^slider-/, '')) || null;
    }
    if (!kind) return;
    var selStart = null;
    var selEnd = null;
    try {
      if (el.tagName === 'INPUT' && typeof el.selectionStart === 'number') {
        selStart = el.selectionStart;
        selEnd = el.selectionEnd;
      }
    } catch (err) {}
    __adaGloboPriceFocus = {
      kind: kind,
      filterId: filterId,
      selectionStart: selStart,
      selectionEnd: selEnd,
      ts: Date.now()
    };
  }

  function adaFindGloboPriceControl(state) {
    if (!state || !state.kind) return null;
    var id = state.filterId;
    if (state.kind === 'min') {
      return (id && document.getElementById('min-' + id)) ||
        document.querySelector('input.gf-range-min');
    }
    if (state.kind === 'max') {
      return (id && document.getElementById('max-' + id)) ||
        document.querySelector('input.gf-range-max');
    }
    var root = id
      ? (document.getElementById('slider-' + id) ||
         document.querySelector('.gf-range-slider[data-id="' + id + '"]') ||
         document.querySelector('#gf-tree'))
      : document.getElementById('gf-tree') || document;
    if (!root) root = document;
    if (state.kind === 'handle-lower') {
      return root.querySelector('.noUi-handle-lower, .noUi-handle[data-handle="0"]');
    }
    if (state.kind === 'handle-upper') {
      return root.querySelector('.noUi-handle-upper, .noUi-handle[data-handle="1"]');
    }
    return null;
  }

  function adaAnnounceGloboPrice() {
    var min = document.querySelector('input.gf-range-min');
    var max = document.querySelector('input.gf-range-max');
    if (!min && !max) return;
    var live = adaGloboPriceLiveRegion();
    var msg = 'Price filter updated';
    if (min && max) msg += ': minimum ' + min.value + ', maximum ' + max.value;
    else if (min) msg += ': minimum ' + min.value;
    else if (max) msg += ': maximum ' + max.value;
    // Clear then set so polite AT re-announces on repeat applies
    live.textContent = '';
    if (__adaGloboPriceAnnounceTimer) clearTimeout(__adaGloboPriceAnnounceTimer);
    __adaGloboPriceAnnounceTimer = setTimeout(function () {
      live.textContent = msg;
    }, 40);
  }

  function adaRestoreGloboPriceFocus(announce) {
    var state = __adaGloboPriceFocus;
    if (!state) return;
    // Ignore stale captures (>8s) — user moved on
    if (state.ts && Date.now() - state.ts > 8000) {
      __adaGloboPriceFocus = null;
      return;
    }
    var el = adaFindGloboPriceControl(state);
    if (!el) return;
    var ae = document.activeElement;
    if (ae === el) {
      if (announce) adaAnnounceGloboPrice();
      return;
    }
    // Only steal focus back if it fell to body/html or was lost with the old node
    if (ae && ae !== document.body && ae !== document.documentElement &&
        ae.tagName !== 'BODY' && ae.tagName !== 'HTML') {
      // Another control took focus intentionally — clear stash
      if (!ae.closest || !ae.closest('#gf-tree, .gf-range-inputs, .noUi-target, .gf-range-slider')) {
        __adaGloboPriceFocus = null;
        return;
      }
    }
    try {
      if (typeof el.focus === 'function') el.focus({ preventScroll: true });
      else el.focus();
    } catch (err2) {
      try { el.focus(); } catch (err3) {}
    }
    if (el.tagName === 'INPUT' && state.selectionStart != null) {
      try {
        var len = (el.value || '').length;
        var a = Math.min(state.selectionStart, len);
        var b = Math.min(state.selectionEnd != null ? state.selectionEnd : a, len);
        el.setSelectionRange(a, b);
      } catch (err4) {}
    }
    if (announce) adaAnnounceGloboPrice();
  }

  function adaScheduleGloboPriceFocusRestore() {
    if (!__adaGloboPriceFocus) return;
    if (__adaGloboPriceRestoreTimer) {
      clearTimeout(__adaGloboPriceRestoreTimer);
      __adaGloboPriceRestoreTimer = null;
    }
    var delays = [0, 50, 150, 350, 700];
    delays.forEach(function (ms, idx) {
      setTimeout(function () {
        adaRestoreGloboPriceFocus(idx === delays.length - 1);
      }, ms);
    });
  }

  function bindGloboPriceKeyboardFocus() {
    if (window.__adaGloboPriceKbdBound) return;
    window.__adaGloboPriceKbdBound = true;
    adaGloboPriceLiveRegion();

    function onFocusIn(e) {
      adaCaptureGloboPriceFocus(e.target);
    }
    function onChange(e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (t.classList.contains('gf-range-min') || t.classList.contains('gf-range-max') ||
          (t.id && (t.id.indexOf('min-') === 0 || t.id.indexOf('max-') === 0))) {
        adaCaptureGloboPriceFocus(t);
        adaScheduleGloboPriceFocusRestore();
      }
    }
    function onKeyDown(e) {
      var t = e.target;
      if (!t) return;
      if (t.classList && t.classList.contains('noUi-handle')) {
        adaCaptureGloboPriceFocus(t);
        // Arrow/Home/End/Page* change the slider; Globo refreshes on change
        if (/^Arrow|Home|End|Page/.test(e.key || '')) {
          adaScheduleGloboPriceFocusRestore();
        }
      }
      if (t.classList && (t.classList.contains('gf-range-min') || t.classList.contains('gf-range-max'))) {
        adaCaptureGloboPriceFocus(t);
        if (e.key === 'Enter') adaScheduleGloboPriceFocusRestore();
      }
    }

    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('change', onChange, true);
    document.addEventListener('keydown', onKeyDown, true);

    window.addEventListener('globoFilterTreeRenderCompleted', function () {
      adaScheduleGloboPriceFocusRestore();
    });
    window.addEventListener('globoFilterRenderCompleted', function () {
      adaScheduleGloboPriceFocusRestore();
    });

    // noUi may fire change without bubbling through our capture if destroyed mid-flight;
    // MutationObserver on tree childList also schedules restore when stash present.
    if (!window.__adaGloboPriceTreeObs) {
      try {
        var obs = new MutationObserver(function (mutations) {
          if (!__adaGloboPriceFocus) return;
          for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (m.addedNodes && m.addedNodes.length) {
              adaScheduleGloboPriceFocusRestore();
              return;
            }
          }
        });
        var tree = document.getElementById('gf-tree');
        if (tree) obs.observe(tree, { childList: true, subtree: true });
        else obs.observe(document.documentElement, { childList: true, subtree: true });
        window.__adaGloboPriceTreeObs = obs;
      } catch (err5) {}
    }
  }


  /* J. Globo Back-in-Stock / Preorder — empty form labels (WAVE Empty form label)
   * App emits <label></label> when showLabel:false, and email label for=
   * "gBackInStock-Label" does not match input#email. Fill sr-only label text,
   * correct for=, and set aria-label on controls. Sitewide via MutationObserver.
   * 2026-09-23
   */
  function fixGloboBisFormLabels(root) {
    root = root || document;

    root.querySelectorAll('label.gBackInStock-Label[for="selectVariant"], label[for="selectVariant"].gBackInStock-Label').forEach(function (lab) {
      if (!String(lab.textContent || '').trim()) {
        lab.textContent = 'Select variant';
      }
      if (!lab.classList.contains('visually-hidden')) {
        lab.classList.add('visually-hidden');
      }
    });

    root.querySelectorAll('label[for="gBackInStock-Label"]').forEach(function (lab) {
      lab.setAttribute('for', 'email');
      if (!String(lab.textContent || '').trim()) {
        lab.textContent = 'Email';
      }
      if (!lab.classList.contains('visually-hidden')) {
        lab.classList.add('visually-hidden');
      }
    });

    // Also catch empty labels inside Globo BIS form that point at email via class
    root.querySelectorAll('.gBackInStock-Form > label:not([for]), #Globo-Back-In-Stock label').forEach(function (lab) {
      var fr = lab.getAttribute('for') || '';
      if (fr === 'selectVariant') return;
      if ((!lab.textContent || !String(lab.textContent).trim()) && (fr === 'email' || fr === 'gBackInStock-Label' || fr === '')) {
        var emailNearby = lab.parentElement && lab.parentElement.querySelector('input[type="email"], input#email');
        if (emailNearby) {
          if (emailNearby.id) lab.setAttribute('for', emailNearby.id);
          else {
            emailNearby.id = 'email';
            lab.setAttribute('for', 'email');
          }
          lab.textContent = 'Email';
          lab.classList.add('visually-hidden');
        }
      }
    });

    root.querySelectorAll('#selectVariant, select.gBackInStock-Form-Select').forEach(function (sel) {
      sel.setAttribute('aria-label', 'Select variant');
    });
    root.querySelectorAll('input.gBackInStock-Form-Content-Input[type="email"], #Globo-Back-In-Stock input[type="email"], .gBackInStock-Form input#email').forEach(function (inp) {
      inp.setAttribute('aria-label', 'Email');
    });
  }

  /* I. Footer nav landmark labels */
  function labelFooterNavs() {
    var footer = document.querySelector('footer, .footer');
    if (!footer) return;
    var navs = footer.querySelectorAll('nav');
    navs.forEach(function (nav, i) {
      if (nav.getAttribute('aria-label')) return;
      var heading = nav.previousElementSibling;
      var label = heading && /^H[1-6]$/i.test(heading.tagName) ? heading.textContent.trim() : '';
      if (!label) {
        var block = nav.closest('.footer-block');
        var h = block && block.querySelector('.footer-block__heading, h2, h3');
        label = h ? (h.textContent || '').trim() : 'Footer links ' + (i + 1);
      }
      nav.setAttribute('aria-label', label || 'Footer');
    });
    // Also label header duplicate navs lightly if unlabeled
    document.querySelectorAll('nav.header__inline-menu:not([aria-label])').forEach(function (nav) {
      nav.setAttribute('aria-label', 'Main menu');
    });
  }

  /* J. Fether keyboard / scrollable region */
  function fixFetherKeyboard(root) {
    root = root || document;
    root.querySelectorAll('.ft-slider__item-media-list, ft-slider .ft-slider__item-media-list').forEach(function (list) {
      // Prefer existing controls; otherwise make region focusable with arrow keys
      var slider = list.closest('.ft-slider, ft-slider') || list.parentElement;
      var hasControls =
        slider &&
        slider.querySelector('button, [role="button"], .ft-slider__arrow, [data-ft-nav]');
      if (!hasControls) {
        if (!list.hasAttribute('tabindex')) list.setAttribute('tabindex', '0');
        setIfEmpty(list, 'role', 'region');
        setIfEmpty(list, 'aria-label', 'Product images');
        if (!list.dataset.adaKeyNav) {
          list.dataset.adaKeyNav = '1';
          list.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') {
              list.scrollBy({ left: 120, behavior: 'smooth' });
              e.preventDefault();
            } else if (e.key === 'ArrowLeft') {
              list.scrollBy({ left: -120, behavior: 'smooth' });
              e.preventDefault();
            }
          });
        }
      }
      // Soften autoplay attribute when present (visual only; may need Fether app setting)
      if (list.getAttribute('data-autoplay') === 'true') {
        list.setAttribute('data-autoplay', 'false');
      }
    });
  }

  /* F. Collection H1 — if missing, promote banner heading or inject */
  function ensureCollectionH1() {
    // Speed phase 1 note: deliberately still checks only 'template-collection' (never present on this theme), so this block
    // stays off. Turning it on swaps the banner title to an h1 and makes it much larger (28px -> 78px). The page already
    // gets a level-1 heading from ada-a11y-batch.js (aria-level=1 on the banner title).
    if (!document.body.classList.contains('template-collection')) return;
    if (document.querySelector('main h1, #MainContent h1, h1')) return;
    var banner = document.querySelector(
      '.collection-hero__title, .banner__heading, .title-wrapper h2, h2.banner__heading'
    );
    if (banner && /^H2$/i.test(banner.tagName)) {
      var h1 = document.createElement('h1');
      h1.className = banner.className;
      h1.innerHTML = banner.innerHTML;
      banner.parentNode.replaceChild(h1, banner);
      return;
    }
    // Last resort: use document title before em dash
    var main = document.querySelector('#MainContent, main');
    if (!main) return;
    var t = (document.title || '').split(/[–—|-]/)[0].trim();
    if (!t) return;
    var el = document.createElement('h1');
    el.className = 'collection-hero__title ada-injected-h1';
    el.textContent = t;
    el.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0';
    main.insertBefore(el, main.firstChild);
  }



  /* L. WAVE-09 — redundant adjacent links (same destination)
   * WAVE flags adjacent <a href> with the same destination regardless of
   * aria-hidden. Prior pass only aria-hid decorative siblings; re-WAVE still
   * counted ~23. Demote duplicates by stripping href (keep one accessible
   * named link). Host-aware norm so twitter.com/x ≠ facebook.com/x.
   */
  // FH-A11Y batch 13 (2026-09-26): strict mode keeps the ?query and #section, so different filters and
  // different sections of a page no longer count as the same link. Card mode ignores only ?variant=.
  var __adaNormCache = {};
  function normHref(href, strict) {
    if (!href) return '';
    // Cache only addresses that do not depend on the current page address (they start with / or http).
    if (!/^(\/|https?:)/i.test(String(href).trim())) return normHrefRaw(href, strict);
    var ck = (strict ? '1|' : '0|') + href;
    if (Object.prototype.hasOwnProperty.call(__adaNormCache, ck)) return __adaNormCache[ck];
    return (__adaNormCache[ck] = normHrefRaw(href, strict));
  }
  function normHrefRaw(href, strict) {
    if (!href) return '';
    var raw = String(href).trim();
    if (!raw || raw === '#' || raw.indexOf('javascript:') === 0) return '';
    try {
      var a = document.createElement('a');
      a.href = raw;
      var path = a.pathname || '';
      if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
      var search = (a.search || '').replace(/([?&])variant=[^&]*&?/i, '$1').replace(/[?&]$/, '');
      return (a.protocol + '//' + a.host + path + (strict ? a.search : search) + a.hash).toLowerCase();
    } catch (e) {
      return raw.toLowerCase();
    }
  }

  function linkScore(a) {
    var text = (a.textContent || '').replace(/ /g, ' ').trim();
    var cls = String(a.className || '');
    var score = 0;
    if (text) score += 10 + Math.min(text.length, 40);
    if (/ga-product_title|card__heading|full-unstyled-link|product__view-details|product__title/i.test(cls)) score += 50;
    if (a.closest('.card__heading, h3, h2, h1')) score += 30;
    if (a.querySelector('img') && !text) score -= 20; // prefer titled over bare image
    if (!text && !a.getAttribute('aria-label')) score -= 5;
    // FH-A11Y-2026-09-26: never keep a link that isn't rendered (hidden card copy); keeps visible card links working for keyboard/screen readers.
    if (!a.getClientRects().length) score -= 1000;
    return score;
  }

  function demoteDuplicateLink(a, keep) {
    if (!a || a === keep) return;
    if (a.getAttribute('data-ada-wave09') === 'demoted') return;
    var href = a.getAttribute('href');
    if (!href) return;
    a.setAttribute('data-ada-href', href);
    a.removeAttribute('href');
    a.setAttribute('aria-hidden', 'true');
    a.setAttribute('tabindex', '-1');
    a.setAttribute('role', 'presentation');
    a.setAttribute('data-ada-wave09', 'demoted');
    var img = a.querySelector('img');
    if (img && !(img.getAttribute('alt') || '').trim()) {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    }
    if (a.getAttribute('data-ada-wave09-click') !== '1') {
      a.setAttribute('data-ada-wave09-click', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var url =
          (keep && keep.getAttribute('href')) ||
          a.getAttribute('data-ada-href');
        if (url) {
          if (keep && keep.getAttribute('href') && typeof keep.click === 'function') {
            keep.click();
          } else {
            window.location.href = url;
          }
        }
      });
    }
  }

  function exposeKeep(a) {
    if (!a) return;
    if (a.getAttribute('aria-hidden') === 'true') a.removeAttribute('aria-hidden');
    if (a.getAttribute('role') === 'presentation') a.removeAttribute('role');
    if (a.getAttribute('tabindex') === '-1' && (a.textContent || '').trim()) {
      a.removeAttribute('tabindex');
    }
    // If a prior pass demoted the keeper, restore href
    if (!a.getAttribute('href') && a.getAttribute('data-ada-href')) {
      a.setAttribute('href', a.getAttribute('data-ada-href'));
      a.removeAttribute('data-ada-wave09');
    }
  }

  function demoteGroup(group) {
    if (!group || group.length < 2) return;
    var keep = group[0];
    var best = linkScore(keep);
    for (var i = 1; i < group.length; i++) {
      var s = linkScore(group[i]);
      if (s > best) {
        keep = group[i];
        best = s;
      }
    }
    exposeKeep(keep);
    for (var j = 0; j < group.length; j++) {
      if (group[j] !== keep) demoteDuplicateLink(group[j], keep);
    }
  }

  function fixRedundantProductLinks(root) {
    root = root || document;

    // 1) Card / related / quick-add scopes: any same-destination multiples
    var cards = root.querySelectorAll(
      '.ga-product, .gowl-item, .card-wrapper, li.grid__item .card, .quick-add-modal__content-info, .product__info-container, .product__title, .spf-product-card'
    );
    cards.forEach(function (card) {
      var links = Array.prototype.slice.call(card.querySelectorAll('a[href], a[data-ada-href]'));
      if (links.length < 2) return;
      var byHref = {};
      links.forEach(function (a) {
        var h = normHref(a.getAttribute('href') || a.getAttribute('data-ada-href'));
        if (!h) return;
        (byHref[h] = byHref[h] || []).push(a);
      });
      Object.keys(byHref).forEach(function (h) {
        demoteGroup(byHref[h]);
      });
    });

    // 2) Adjacent duplicates outside cards. FH-A11Y batch 13 (2026-09-26): this used to compare any two
    //    consecutive links on the whole page with the ?query and #section cut off, so it hid genuinely
    //    different links (Terms table of contents, filtered collection links, email links in separate
    //    boxes). Now two links only count as duplicates when the full address matches exactly, neither is
    //    an email/phone link, and they sit in the same small container (same parent or grandparent).
    var all = Array.prototype.slice.call(document.querySelectorAll('a[href]'));
    function near(a, b) {
      var pa = a.parentElement, pb = b.parentElement;
      if (!pa || !pb) return false;
      if (pa === pb) return true;
      var ga = pa.parentElement, gb = pb.parentElement;
      return !!ga && (ga === pb || gb === pa || ga === gb) && ga !== document.body && ga.tagName !== 'MAIN';
    }
    var i = 0;
    while (i < all.length) {
      var href0 = all[i].getAttribute('href') || '';
      var h = /^(mailto|tel):/i.test(href0) ? '' : normHref(href0, true);
      if (!h) {
        i++;
        continue;
      }
      var run = [all[i]];
      var k = i + 1;
      while (k < all.length && normHref(all[k].getAttribute('href'), true) === h && near(run[run.length - 1], all[k])) {
        run.push(all[k]);
        k++;
      }
      if (run.length >= 2) demoteGroup(run);
      i = k;
    }
  }

  /* K. WAVE-02 — empty headings (esp. Globo Related Products null subtitle) */
  function fixEmptyHeadings(root) {
    root = root || document;
    var nodes = root.querySelectorAll('h1,h2,h3,h4,h5,h6');
    nodes.forEach(function (h) {
      if ((h.textContent || '').replace(/ /g, ' ').trim()) return;
      // Also empty when only whitespace / decorative children with no text
      var clone = h.cloneNode(true);
      // Keep if aria-label provides accessible name
      if ((h.getAttribute('aria-label') || '').trim()) return;
      var inRelated =
        !!h.closest(
          '#ga-product_related, .ga-product_related, .globoRelatedProducts, .globoRelatedProductsCustom, .ga-carousel_wrapper, [class*="ga-product"], [id*="related"]'
        ) ||
        /ga-|globo|related|gowl|subtitle/i.test(
          String(h.className || '') +
            ' ' +
            String((h.parentElement && h.parentElement.className) || '') +
            ' ' +
            String((h.parentElement && h.parentElement.id) || '')
        );
      // Empty headings are invalid; remove. Near Related Products this clears WAVE-02.
      if (h.parentNode) h.parentNode.removeChild(h);
    });
    // role=heading with empty name
    root.querySelectorAll('[role="heading"]').forEach(function (h) {
      if ((h.textContent || '').replace(/ /g, ' ').trim()) return;
      if ((h.getAttribute('aria-label') || '').trim()) return;
      if (h.parentNode) h.parentNode.removeChild(h);
    });
  }


  /* L. PDP gallery Slick list/listitem (axe Serious) — 2026-09-23
   * Cause: assets/script.js runs Slick on BOTH:
   *   - $('.thumbnail-list.slider') — arrows:true → button.slick-prev/next + div.slick-list
   *     as direct children of ul#Slider-Thumbnails-…; lis wrapped under .slick-track
   *   - $('.product__media-list') — arrows:false but still wraps li#Slide-template-…
   *     under .slick-track (parent is div, not ul) → axe `listitem` on main slides
   * Native list/listitem break either way. Dawn media-gallery.js removeListSemantic
   * already intends role=presentation on the main viewer, but it only runs under a
   * narrow desktopLayout+mql guard and does not cover Slick-rewritten thumbnails /
   * late slickFilter refresh.
   * Fix: strip list semantics on thumbnail AND main product media lists + their lis.
   * Thumbnail <button>s, slick arrows, media modal openers stay real controls; keyboard unchanged.
   * Reversible: delete this block + its runAll() call.
   * Do NOT touch Globo BIS block above. Do NOT touch Merchantverse (Google badge) — EXCEPT: frame-title
   * exception approved 2026-09-25 (title attribute only, see GOOGLE BADGE FRAME TITLE block at end of file;
   * nothing else in Google's badge is touched).
   */
  function fixThumbnailSliderListSemantics(root) {
    root = root || document;
    // Thumbnails
    root.querySelectorAll('ul[id^="Slider-Thumbnails"]').forEach(function (ul) {
      ul.setAttribute('role', 'presentation');
      ul.setAttribute('data-ada-axe-gallery', 'list-semantics-stripped');
    });
    root.querySelectorAll(
      'li[id^="Slide-Thumbnails"], ul[id^="Slider-Thumbnails"] li.thumbnail-list__item, ul[id^="Slider-Thumbnails"] li.thumbnaillistitem, .thumbnail-list.slider li.slick-slide'
    ).forEach(function (li) {
      li.setAttribute('role', 'presentation');
    });
    // Main product media gallery (ul#Slider-Gallery-… / .product__media-list)
    root.querySelectorAll(
      'ul.product__media-list, ul[id^="Slider-Gallery"], ul.productmainslider'
    ).forEach(function (ul) {
      ul.setAttribute('role', 'presentation');
      ul.setAttribute('data-ada-axe-gallery', 'main-list-semantics-stripped');
    });
    root.querySelectorAll(
      'li[id^="Slide-template-"]:not(.multicolumn-list__item), ul.product__media-list li.product__media-item, ul.product__media-list li.mainproductslide, ul.product__media-list li.mainsliderproductslide, ul.product__media-list li.slick-slide, .product__media-list.slider li.slick-slide'
    ).forEach(function (li) {
      li.setAttribute('role', 'presentation');
    });
  }


  /* N. PDP gallery thumbnail keyboard / names — 2026-09-23
   * Smoke P1 (KEYBOARD_SMOKE): thumbs unnamed / behind aria-hidden; Enter did not
   * change main image; focus unclear; disabled Previous still focused.
   * Cause: Slick initADA hides non-active lis (aria-hidden) while buttons may still
   * surface oddly; media-gallery.js thumb click→setActiveMedia is commented out so
   * activation depends on fragile focusOnSelect bubbling; focus CSS only for
   * [aria-current]; slick-disabled arrows stay tabbable.
   * HARDEN 2026-09-23 (~21:40 ET): VERIFY Partial — vertical centerMode thumb rail
   * often shows slides WITHOUT slick-active/current/center, so class-only gate left
   * on-screen peers aria-hidden; Slick initADA can re-hide after our pass.
   * Harden (still Block N; no Slick option rewrite; keeps Block L; no Block M;
   * does NOT touch fixGloboBisFormLabels):
   *   1) Label each non-cloned thumb button "Show image N of M"; sync aria-current
   *   2) Visibility via getBoundingClientRect ∩ .slick-list (overlap >~10% thumb
   *      height OR >8px); fallback slick-active/current/center OR unhide all if
   *      not slick-initialized / no .slick-list
   *   3) Visible: aria-hidden=false + remove tabindex=-1; off-screen originals:
   *      aria-hidden=true + tabindex=-1; clones stay inert; strip aria-modal
   *   4) Delegated click / Enter / Space → slick('slickGoTo', index) when available
   *   5) tabindex=-1 on thumbnail slick-disabled arrows; restore when enabled
   *   6) Per-ul MutationObserver on aria-hidden/class (debounce 50–100ms); disconnect
   *      briefly while applying to avoid loops
   * Re-apply via runAll + boot retries + afterChange + thumb observers.
   * REAPPLY 2026-09-23 (~21:55 ET): VERIFY still Partial after harden — after
   * thumb activation / Next, mid-animation intersection marks thumbs off-screen
   * (aria-hidden=true); animation end often has no further aria-hidden/class
   * mutation so MutationObserver stays quiet → stuck hidden. Slick initADA may
   * also re-hide after our synchronous afterChange apply.
   * Fix (still Block N): adaScheduleThumbGalleryFix(root) runs fix at
   * 0/50/150/350/700ms (clear prior timers per root); call from afterChange,
   * activateFromEvent after slickGoTo, MutationObserver (debounced schedule),
   * and optional setPosition. Always force aria-hidden=false on visible lis.
   */
  var ADA_KBD_GALLERY_BOUND = false;
  var ADA_KBD_GALLERY_APPLYING = false;
  var ADA_KBD_GALLERY_OBS = [];
  // Per-root scheduled re-apply timers (afterChange / slickGoTo animation race)
  var ADA_KBD_GALLERY_SCHEDULE = [];

  function adaThumbSliders(root) {
    root = root || document;
    var list = [];
    root.querySelectorAll('ul[id^="Slider-Thumbnails"], .thumbnail-list.slider.slick-initialized, .thumbnail-list.thumbnailslider').forEach(function (ul) {
      if (list.indexOf(ul) === -1) list.push(ul);
    });
    return list;
  }

  function adaThumbOriginalSlides(ul) {
    var slides = ul.querySelectorAll('li.slick-slide:not(.slick-cloned)');
    if (slides.length) return slides;
    return ul.querySelectorAll('li[id^="Slide-Thumbnails"], li.thumbnail-list__item, li.thumbnaillistitem');
  }

  function adaThumbGoTo(ul, index) {
    if (index == null || index < 0 || isNaN(index)) return false;
    try {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        var $ul = window.jQuery(ul);
        if ($ul.hasClass('slick-initialized')) {
          $ul.slick('slickGoTo', index);
          return true;
        }
      }
    } catch (err) { /* ignore */ }
    return false;
  }

  function adaSyncThumbCurrent(ul, index) {
    var slides = adaThumbOriginalSlides(ul);
    slides.forEach(function (li, i) {
      var btn = li.querySelector('button.thumbnail');
      if (!btn) return;
      if (i === index) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
  }

  /** Meaningful intersection of thumb li vs .slick-list (or list wrapper). */
  function adaThumbIntersectsList(li, listEl) {
    if (!listEl || !li.getBoundingClientRect) return null;
    var a = li.getBoundingClientRect();
    var b = listEl.getBoundingClientRect();
    if (!a.width && !a.height) return false;
    var top = Math.max(a.top, b.top);
    var bottom = Math.min(a.bottom, b.bottom);
    var left = Math.max(a.left, b.left);
    var right = Math.min(a.right, b.right);
    var oh = Math.max(0, bottom - top);
    var ow = Math.max(0, right - left);
    if (ow <= 0 || oh <= 0) return false;
    var thumbH = Math.max(a.height, 1);
    // Visible if overlap height > ~10% of thumb OR any overlap > 8px
    return (oh / thumbH) > 0.1 || oh > 8 || ow > 8;
  }

  function adaThumbListViewport(ul) {
    var list = ul.querySelector('.slick-list');
    if (list) return list;
    // Fallback: track / parent that clips the rail
    var track = ul.querySelector('.slick-track');
    if (track && track.parentElement && track.parentElement !== ul) return track.parentElement;
    return null;
  }

  function adaThumbIsVisible(li, ul, slickReady, listEl) {
    if (!slickReady) return true; // SSR / pre-init: keep originals tabbable
    if (listEl) {
      var hit = adaThumbIntersectsList(li, listEl);
      if (hit !== null) return hit;
    }
    // No .slick-list (or rect unavailable): class fallback
    return li.classList.contains('slick-active') ||
      li.classList.contains('slick-current') ||
      li.classList.contains('slick-center');
  }


  /** Re-run thumb keyboard fix across Slick animation / initADA race windows. */
  function adaScheduleThumbGalleryFix(root) {
    root = root || document;
    // Clear previous timers for the same root to avoid pile-up
    for (var i = 0; i < ADA_KBD_GALLERY_SCHEDULE.length; i++) {
      if (ADA_KBD_GALLERY_SCHEDULE[i].root === root) {
        var oldTimers = ADA_KBD_GALLERY_SCHEDULE[i].timers || [];
        for (var t = 0; t < oldTimers.length; t++) {
          try { clearTimeout(oldTimers[t]); } catch (eClr) { /* ignore */ }
        }
        ADA_KBD_GALLERY_SCHEDULE.splice(i, 1);
        break;
      }
    }
    var delays = [0, 50, 150, 350, 700];
    var entry = { root: root, timers: [] };
    ADA_KBD_GALLERY_SCHEDULE.push(entry);
    for (var d = 0; d < delays.length; d++) {
      (function (delay) {
        entry.timers.push(setTimeout(function () {
          fixThumbnailGalleryKeyboard(root);
        }, delay));
      })(delays[d]);
    }
  }

  function fixThumbnailGalleryKeyboard(root) {
    root = root || document;
    ADA_KBD_GALLERY_APPLYING = true;

    try {
      adaThumbSliders(root).forEach(function (ul) {
        ul.setAttribute('data-ada-kbd-gallery', 'thumb-rail');

        // Clones stay inert
        ul.querySelectorAll('li.slick-slide.slick-cloned').forEach(function (li) {
          li.setAttribute('aria-hidden', 'true');
          if (li.hasAttribute('aria-modal')) li.removeAttribute('aria-modal');
          li.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
            el.setAttribute('tabindex', '-1');
          });
        });

        var slides = adaThumbOriginalSlides(ul);
        var total = slides.length;
        var slickReady = ul.classList.contains('slick-initialized');
        var listEl = adaThumbListViewport(ul);
        // If initialized but no list viewport found, unhide all originals (safer tab stream)
        var unhideAllFallback = slickReady && !listEl;

        slides.forEach(function (li, i) {
          // Invalid on a thumbnail list item; strip if present
          if (li.getAttribute('aria-modal') === 'true') li.removeAttribute('aria-modal');

          var btn = li.querySelector('button.thumbnail');
          if (!btn) return;

          var n = i + 1;
          var isCurrent = btn.getAttribute('aria-current') === 'true' || li.classList.contains('slick-current');
          var label = 'Show image ' + n + ' of ' + total + (isCurrent ? ', selected' : '');
          btn.setAttribute('aria-label', label);
          btn.setAttribute('data-ada-kbd-gallery-thumb', String(n));
          btn.setAttribute('type', 'button');

          var isVisible = unhideAllFallback || adaThumbIsVisible(li, ul, slickReady, listEl);

          if (isVisible) {
            // Always force false (overwrite Slick initADA), not only when currently true
            li.setAttribute('aria-hidden', 'false');
            li.setAttribute('data-ada-kbd-gallery-unhide', '1');
            if (btn.getAttribute('tabindex') === '-1') btn.removeAttribute('tabindex');
            else if (btn.hasAttribute('tabindex') && btn.getAttribute('tabindex') !== '0') {
              btn.setAttribute('tabindex', '0');
            }
          } else {
            li.setAttribute('aria-hidden', 'true');
            btn.setAttribute('tabindex', '-1');
          }
        });

        // Disabled prev/next: skip in tab order; restore when enabled
        ul.querySelectorAll('button.slick-prev, button.slick-next, .slick-prev, .slick-next').forEach(function (arrow) {
          if (!(ul === arrow.parentElement || ul.contains(arrow))) return;
          var disabled = arrow.classList.contains('slick-disabled') ||
            arrow.getAttribute('aria-disabled') === 'true' ||
            arrow.hasAttribute('disabled');
          if (disabled) {
            arrow.setAttribute('tabindex', '-1');
            arrow.setAttribute('aria-disabled', 'true');
            arrow.setAttribute('data-ada-kbd-gallery-arrow', 'disabled');
          } else {
            if (arrow.getAttribute('data-ada-kbd-gallery-arrow') === 'disabled' || arrow.getAttribute('tabindex') === '-1') {
              arrow.removeAttribute('tabindex');
            }
            arrow.setAttribute('aria-disabled', 'false');
            arrow.setAttribute('data-ada-kbd-gallery-arrow', 'enabled');
          }
        });

        // Lightweight re-apply observer for Slick aria-hidden / class races
        adaEnsureThumbGalleryObserver(ul);
      });
    } finally {
      // Release on next tick so attribute mutations from this pass are ignored
      setTimeout(function () { ADA_KBD_GALLERY_APPLYING = false; }, 0);
    }

    // Main-gallery asNavFor sibling arrows are labelled by Block A; only thumb rail here.
  }

  function adaEnsureThumbGalleryObserver(ul) {
    if (!ul || ul.getAttribute('data-ada-kbd-gallery-obs') === '1') return;
    if (typeof MutationObserver === 'undefined') return;
    ul.setAttribute('data-ada-kbd-gallery-obs', '1');

    var timer = null;
    var obs = new MutationObserver(function () {
      if (ADA_KBD_GALLERY_APPLYING) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        if (ADA_KBD_GALLERY_APPLYING) return;
        // Disconnect briefly while applying to avoid observation loops
        try { obs.disconnect(); } catch (e1) { /* ignore */ }
        try {
          // Debounced schedule (not only immediate) covers post-animation settle
          adaScheduleThumbGalleryFix(ul.parentElement || document);
        } finally {
          try {
            obs.observe(ul, {
              subtree: true,
              attributes: true,
              attributeFilter: ['aria-hidden', 'class']
            });
          } catch (e2) { /* ignore */ }
        }
      }, 75);
    });

    try {
      obs.observe(ul, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });
      ADA_KBD_GALLERY_OBS.push(obs);
    } catch (e3) { /* ignore */ }
  }


  /* ========================================================================
   * Block Q — Strip redundant title attributes (WAVE-12 hygiene)
   * DRAFT overnight 2026-09-23 — ADA overnight title+headings theme
   * CoS DOM audit: home 16 redundant = ALL a.tmenu_item_link (Qikify).
   * Outdoor Rugs 133 = 16 nav + ~90 spf-product__swatch + ~27 other.
   * SCOPE (allowlist when title === visible text via adaNormTitleText):
   *   - a.tmenu_item_link (Qikify top nav — Suchin confirmed fixed)
   *   - #gf-tree a[title] (Globo side-menu facets)
   *   - .spf-product__swatch[title] (product size/value swatches — Suchin 2026-09-24
   *     approved; no longer parked for draft). Primary Liquid remove in
   *     snippets/globo.filter.product.liquid; Block Q belt+suspenders for AJAX.
   * Primary Liquid (facets): snippets/globo.filter.tree.liquid — removed
   *   title={{value_label}} on Checkbox/Radio/Box/Rating (2026-09-24).
   * Reversible: delete this block + its calls from runAll/boot.
   * Does NOT touch Globo BIS, Block L/N/P, Featured sort.
   * ======================================================================== */
  function adaNormTitleText(s) {
    return String(s || '')
      .replace(/\s+/g, ' ')
      .replace(/ /g, ' ')
      .trim()
      .toLowerCase();
  }

  

  /* ========================================================================
   * Block S — Label Globo product-card variant <select> (WAVE Select missing label)
   * DRAFT 2026-09-24 — Outdoor Rugs ~18 hidden .spf-product__variants per page.
   * Liquid sets aria-label + id; this re-applies after Globo AJAX card refresh.
   * Prefer product title from card link; fallback "Product variant".
   * Does NOT touch Featured sort UI / Block M / Globo BIS / L/N/P/Q.
   * Reversible: delete this block + its calls.
   * ======================================================================== */
  function adaLabelSpfVariantSelects(root) {
    root = root || document;
    var selects;
    try {
      selects = root.querySelectorAll('select.spf-product__variants');
    } catch (e) {
      return;
    }
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      if (!sel || !sel.getAttribute) continue;
      var hasName = false;
      var al = sel.getAttribute('aria-label');
      if (al && String(al).trim()) hasName = true;
      var alb = sel.getAttribute('aria-labelledby');
      if (alb && String(alb).trim()) hasName = true;
      if (sel.id) {
        try {
          var lab = document.querySelector('label[for="' + sel.id.replace(/"/g, '\\"') + '"]');
          if (lab && (lab.textContent || '').trim()) hasName = true;
        } catch (e2) { /* ignore */ }
      }
      if (hasName && sel.getAttribute('data-ada-variant-labeled') === '1') continue;
      var title = '';
      try {
        var card = sel.closest('.spf-product-card, .spf-product__form');
        if (card) {
          var a = card.querySelector('.spf-product-card__title a, a.spf-product-card__title, .spf-product-card__title');
          if (a) title = (a.textContent || '').replace(/\s+/g, ' ').trim();
        }
      } catch (e3) { /* ignore */ }
      var label = title ? ('Product variant for ' + title) : 'Product variant';
      sel.setAttribute('aria-label', label);
      sel.setAttribute('data-ada-variant-labeled', '1');
      if (!sel.id) {
        sel.id = 'spf-variants-ada-' + i + '-' + String(Date.now()).slice(-4);
      }
    }
  }


  function stripRedundantTitles(root) {
    root = root || document;
    var nodes;
    try {
      // Allowlist: Qikify top nav + Globo #gf-tree facets + product swatches (WAVE_DRAFT_SWATCH_TITLES)
      nodes = root.querySelectorAll(
        'a.tmenu_item_link[title], #gf-tree a[title], .spf-product__swatch[title]'
      );
    } catch (e) {
      return;
    }
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || !el.getAttribute) continue;
      if (el.getAttribute('data-ada-keep-title') === '1') continue;
      var title = el.getAttribute('title');
      if (title == null) continue;
      if (!String(title).trim()) {
        el.removeAttribute('title');
        continue;
      }
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) continue; // icon-only — keep title
      if (adaNormTitleText(title) !== adaNormTitleText(text)) continue;
      el.removeAttribute('title');
      el.setAttribute('data-ada-title-stripped', '1');
    }
  }

  function bindThumbnailGalleryKeyboard() {
    if (ADA_KBD_GALLERY_BOUND) return;
    ADA_KBD_GALLERY_BOUND = true;

    function activateFromEvent(e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.thumbnail') : null;
      if (!btn) return;
      var li = btn.closest('li.slick-slide, li[id^="Slide-Thumbnails"], li.thumbnail-list__item, li.thumbnaillistitem');
      if (!li || li.classList.contains('slick-cloned')) return;
      var ul = btn.closest('ul[id^="Slider-Thumbnails"], .thumbnail-list.slider, .thumbnailslider');
      if (!ul) return;

      var index = null;
      if (li.hasAttribute('data-slick-index')) {
        index = parseInt(li.getAttribute('data-slick-index'), 10);
      }
      if (index == null || isNaN(index)) {
        var slides = adaThumbOriginalSlides(ul);
        for (var i = 0; i < slides.length; i++) {
          if (slides[i] === li) { index = i; break; }
        }
      }
      if (index == null || isNaN(index)) return;

      // Always sync name/current; prefer Slick API for visual change
      var went = adaThumbGoTo(ul, index);
      adaSyncThumbCurrent(ul, index);
      // Re-apply across animation / initADA race (immediate alone is not enough)
      adaScheduleThumbGalleryFix(document);
      if (went) {
        // Prevent double-handling oddities; allow default button click too if Slick missing
        if (e.type === 'keydown') {
          e.preventDefault();
        }
      } else if (e.type === 'keydown') {
        // Fallback: synthesize click for non-Slick paths
        e.preventDefault();
        try { btn.click(); } catch (err2) { /* ignore */ }
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button.thumbnail') : null;
      if (!btn) return;
      if (!btn.closest('ul[id^="Slider-Thumbnails"], .thumbnail-list.slider, .thumbnailslider')) return;
      activateFromEvent(e);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
      var btn = e.target && e.target.closest ? e.target.closest('button.thumbnail') : null;
      if (!btn) return;
      if (!btn.closest('ul[id^="Slider-Thumbnails"], .thumbnail-list.slider, .thumbnailslider')) return;
      activateFromEvent(e);
    }, true);

    // Keep aria-current in sync when Slick changes (mouse arrows / swipe)
    if (window.jQuery) {
      try {
        var thumbSel = '.thumbnail-list.slider, .thumbnailslider, ul[id^="Slider-Thumbnails"]';
        window.jQuery(document).on('afterChange.adaKbdGallery', thumbSel, function (event, slick, currentSlide) {
          adaSyncThumbCurrent(this, currentSlide);
          // Schedule across animation settle (immediate-only left thumbs stuck hidden)
          adaScheduleThumbGalleryFix(document);
        });
        // Optional: setPosition also fires when Slick reflows after GoTo
        window.jQuery(document).on('setPosition.adaKbdGallery', thumbSel, function () {
          adaScheduleThumbGalleryFix(document);
        });
      } catch (err3) { /* ignore */ }
    }
  }



  function runAll(root) {
    stripRedundantTitles(root);
    labelCarouselButtons(root);
    fixThumbnailSliderListSemantics(root);
    fixThumbnailGalleryKeyboard(root);
    fixFeatureIconAlts(root);
    nameRelatedProductLinks(root);
    nameGloboSliders(root);
    bindGloboPriceKeyboardFocus();
    adaLabelSpfVariantSelects(document);
    if (root && root !== document) stripRedundantTitles(document);
    fixGloboBisFormLabels(root);
    fixFetherKeyboard(root);
    fixEmptyHeadings(root);
    fixRedundantProductLinks(root);
  }

  function boot() {
    fixLogoLink();
    labelFooterNavs();
    ensureCollectionH1();
    runAll(document);
    bindThumbnailGalleryKeyboard();

    // Late widgets (Globo, Gowl, Fether, Slick). Speed phase 1: wait for the page to be quiet, then run once.
    var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, LINK: 1, META: 1, NOSCRIPT: 1 };
    var runTimer = 0, firstPending = 0;
    function runSoon() {
      var now = Date.now();
      if (!firstPending) firstPending = now;
      if (runTimer) clearTimeout(runTimer);
      // Never wait more than about 1 s in total, even if the page keeps changing.
      runTimer = setTimeout(function () {
        runTimer = 0;
        firstPending = 0;
        if (window.requestIdleCallback) window.requestIdleCallback(function () { runAll(document); }, { timeout: 300 });
        else runAll(document);
      }, now - firstPending > 800 ? 0 : 120);
    }
    function meaningful(nodes) {
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && !SKIP_TAGS[n.nodeName]) return true;
      }
      return false;
    }
    var obs = new MutationObserver(function (mutations) {
      var dirty = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length && meaningful(m.addedNodes)) { dirty = true; break; }
        if (m.type === 'attributes' && m.attributeName && m.attributeName.indexOf('aria-') === 0) {
          dirty = true; break;
        }
      }
      if (!dirty) return;
      runSoon();
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'aria-activedescendant']
    });

    // Globo slider ARIA harden — dedicated observer (collection/search pages, or once filter markup appears) + retries
    if (adaIsFilterPage()) observeGloboSliderAria();
    else window.addEventListener('load', function () {
      setTimeout(function () { if (adaIsFilterPage()) { observeGloboSliderAria(); nameGloboSliders(document); } }, 1500);
    });
    bindGloboPriceKeyboardFocus();
    nameGloboSliders(document);
    [2000, 6000].forEach(function (ms) {
      setTimeout(function () {
        nameGloboSliders(document);
        runAll(document);
      }, ms);
    });
  }

  function adaIsFilterPage() {
    var b = document.body;
    if (b && (b.classList.contains('collection') || b.classList.contains('search') || b.classList.contains('template-collection') || b.classList.contains('template-search'))) return true;
    return !!document.querySelector('#gf-tree, .gf-filter, #gf-products, .gf-range-slider');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* FH-A11Y-2026-09-25 GLOBO FILTERS/PAGINATION START */
/* Globo collection filters/pagination a11y, all Globo-powered collection/search pages (Suchin-approved 2026-09-25).
   Reversible: delete everything between START and END markers.
   Rule: ADA-only. Mouse/touch behaviour is unchanged; focus moves happen only after keyboard activation.
   1) Globo checkbox/swatch facets -> keyboard checkboxes (role=checkbox, tabindex=0, aria-checked, Enter/Space, grouped per facet)
   2) Mobile "Filter By" toggle -> button semantics, aria-expanded/controls; keyboard open moves focus into drawer, Escape closes
      (focus back to toggle), closed off-canvas drawer is inert/aria-hidden (not focusable, invisible change)
   3) Globo pagination -> navigation landmark, aria-current, "Page N"/"Next page"/"Previous page"; polite announce after any
      page change; focus moves to the product grid only when the page link was activated from the keyboard
   4) #gf-products (ul) direct div children -> role=listitem
   Sort dropdown intentionally untouched (parked). Globo re-renders its DOM, so a debounced MutationObserver re-applies (idempotent). */
(function(){
  if (window.__fhA11y20260925) return; window.__fhA11y20260925 = true;
  var KEY_FOCUS = null, PAGE_PENDING = false, PAGE_KBD = false, DRAWER_KBD = false, LAST_DRAWER_OPEN = null, t = null;
  function $(s, r){ return (r||document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
  function txt(el){ return (el && el.textContent || '').replace(/\s+/g,' ').trim(); }
  function isAct(e){ return e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'; }
  function live(){
    var el = document.getElementById('fh-a11y-live');
    if (!el){ el = document.createElement('div'); el.id = 'fh-a11y-live'; el.className = 'fh-a11y-sr';
      el.setAttribute('aria-live','polite'); el.setAttribute('role','status'); (document.body||document.documentElement).appendChild(el); }
    return el;
  }
  function announce(msg){ var el = live(); el.textContent = ''; setTimeout(function(){ el.textContent = msg; }, 60); }
  function style(){
    if (document.getElementById('fh-a11y-2026-09-25-style')) return;
    var s = document.createElement('style'); s.id = 'fh-a11y-2026-09-25-style';
    s.textContent = '.fh-a11y-sr{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;border:0!important}'
      + '#gf-tree li[role="checkbox"]:focus-visible{outline:2px solid #404040!important;outline-offset:-2px!important}'   /* inset: Globo option lists clip overflow */
      + '.gf-refine-toggle-mobile:focus-visible,#gf-tree .gf-close-canvas:focus-visible,#gf_pagination_wrap a:focus-visible{outline:2px solid #404040!important;outline-offset:2px!important}'
      + '#gf-products:focus,#gf-products:focus-visible{outline:none!important}';
    (document.head||document.documentElement).appendChild(s);
  }
  function drawerCount(){ var b = $('#gf-tree .gf-filter-footer b'); return b ? txt(b) : null; }

  /* ---------- 1) facets ---------- */
  /* Semantics go on the <li> (not the Globo <a>): Globo's delegated click handler treats a[role=checkbox] as its
     newer button template and reads data-fvalue (undefined), which would add a bogus "undefined" filter value.
     The <a onclick> stays untouched so Globo's own mouse path (incl. scroll-position memory) is unchanged. */
  function sink(){
    var el = document.getElementById('fh-a11y-focus-sink');
    if (!el){ el = document.createElement('span'); el.id = 'fh-a11y-focus-sink'; el.className = 'fh-a11y-sr'; el.setAttribute('tabindex','-1'); el.textContent = 'Updating products'; (document.body||document.documentElement).appendChild(el); }
    return el;
  }
  /* Mouse/touch parity: the tabindex we add must not change where a pointer press puts focus. Drop it for the duration of the
     press so the browser picks the same focus target as today, then restore it (keyboard reachability unchanged). */
  function noPointerFocus(el){
    if (el.__fhNoPtr) return; el.__fhNoPtr = true;
    el.addEventListener('mousedown', function(){ if (el.getAttribute('tabindex') === '0'){ el.removeAttribute('tabindex'); setTimeout(function(){ if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex','0'); }, 0); } });
  }
  function optState(li){ var a = $('a', li); return !!((a && a.classList.contains('checked')) || li.classList.contains('checked')); }
  function fixFacets(){
    $$('#gf-tree .gf-option-block').forEach(function(block){
      var box = $('ul.gf-option-box', block); if (!box) return;
      var fid = block.getAttribute('data-filter-id') || '';
      var titleSpan = $('.gf-block-title .h3 span, .gf-block-title span, .gf-block-title', block);
      if (titleSpan && !titleSpan.id) titleSpan.id = 'fh-gf-title-' + fid;
      if (box.getAttribute('role') !== 'group') box.setAttribute('role','group');
      if (titleSpan && box.getAttribute('aria-labelledby') !== titleSpan.id) box.setAttribute('aria-labelledby', titleSpan.id);
      $$(':scope > li', box).forEach(function(li){
        var a = $(':scope > a', li);
        if (!a || a.hasAttribute('href') || !/toggleCheckboxFilter/.test(a.getAttribute('onclick')||'')) return;
        var label = txt($('.gf-label', a)) || txt(a);
        var cnt = $('.gf-count', a); var name = label + (cnt && txt(cnt) ? ' (' + txt(cnt).replace(/[()]/g,'') + ')' : '');
        var checked = String(optState(li));
        if (li.getAttribute('role') !== 'checkbox') li.setAttribute('role','checkbox');
        if (li.getAttribute('tabindex') !== '0') li.setAttribute('tabindex','0');
        noPointerFocus(li);
        if (li.getAttribute('aria-checked') !== checked) li.setAttribute('aria-checked', checked);
        if (li.getAttribute('aria-label') !== name) li.setAttribute('aria-label', name);
        li.setAttribute('data-fh-gf-key', fid + '|' + label);
        $$('.gf-Checkbox, .gf-option-one-color, .gf-swatch-image', a).forEach(function(d){ if (d.getAttribute('aria-hidden') !== 'true') d.setAttribute('aria-hidden','true'); });
        if (!li.__fhBound){
          li.__fhBound = true;
          li.addEventListener('keydown', function(e){
            if (!isAct(e) || e.target !== li) return;
            e.preventDefault(); e.stopPropagation();
            var was = li.getAttribute('aria-checked') === 'true';
            KEY_FOCUS = { key: li.getAttribute('data-fh-gf-key'), node: li, label: label, now: !was, t: Date.now() };
            /* park focus outside #gf-tree while Globo re-renders so Block P's price-focus restore stands down */
            try { sink().focus({preventScroll:true}); } catch(err){}
            a.click();
            restoreFacetFocus();
          });
        }
      });
    });
  }
  function restoreFacetFocus(){
    var tries = 0;
    (function tick(){
      if (!KEY_FOCUS) return;
      tries++;
      var el = null;
      $$('#gf-tree li[data-fh-gf-key]').forEach(function(x){ if (x.getAttribute('data-fh-gf-key') === KEY_FOCUS.key) el = x; });
      var rerendered = el && el !== KEY_FOCUS.node;
      var timedOut = Date.now() - KEY_FOCUS.t > 4000;
      if (rerendered || timedOut){
        if (!el) el = KEY_FOCUS.node;
        var settle = rerendered ? 250 : 0;   /* let Globo/Block P finish their own post-render work */
        var k = KEY_FOCUS; KEY_FOCUS = null;
        setTimeout(function(){
          var fresh = null; $$('#gf-tree li[data-fh-gf-key]').forEach(function(x){ if (x.getAttribute('data-fh-gf-key') === k.key) fresh = x; });
          fixFacets(); fresh = fresh || el;
          var ae = document.activeElement;
          if (document.contains(fresh) && (!ae || ae === document.body || ae.id === 'fh-a11y-focus-sink' || ae.tagName === 'MAIN' || (ae.closest && ae.closest('#gf-tree')))){
            try { fresh.focus({preventScroll:true}); } catch(e){ fresh.focus(); }
          }
          var c = drawerCount(); var st = fresh.getAttribute('aria-checked') === 'true';
          announce('Filter ' + k.label + (st ? ' selected' : ' cleared') + (c ? '. ' + c + (c === '1' ? ' product.' : ' products.') : '.'));
        }, settle);
        return;
      }
      setTimeout(tick, 60);
    })();
  }

  /* ---------- 2) mobile drawer ---------- */
  /* Globo tracks the off-canvas state with html.offcanvas-open; its toggleCanvas() always writes aria-hidden="false" (even when closing), so derive state from the class */
  function drawerOpen(){ return isMobileDrawer() && document.documentElement.classList.contains('offcanvas-open'); }
  function isMobileDrawer(){ var tr = $('#gf-tree'); return !!(tr && tr.getAttribute('role') === 'dialog'); }
  function focusables(root){ return $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', root).filter(function(el){ return el.offsetWidth || el.offsetHeight || el.getClientRects().length; }); }
  function nativeBtn(el){ return el.tagName === 'BUTTON' || (el.tagName === 'A' && el.hasAttribute('href')); }
  function toggleCanvas(){ if (window.globofilter && typeof window.globofilter.toggleCanvas === 'function') window.globofilter.toggleCanvas(); }
  function fixDrawer(){
    var tr = $('#gf-tree'); var tg = $('.gf-refine-toggle-mobile');
    if (tr){
      var head = $('.gf-filter-heading', tr);
      var lb = tr.getAttribute('aria-labelledby');
      if (lb && head && !document.getElementById(lb)) head.id = lb;       /* repair Globo's dangling gf-filter-title ref */
      var close = $('.gf-close-canvas', tr);
      if (close){
        if (!nativeBtn(close) && close.getAttribute('role') !== 'button') close.setAttribute('role','button');
        if (!nativeBtn(close) && !close.hasAttribute('tabindex')){ close.setAttribute('tabindex','0'); noPointerFocus(close); }
        if (close.getAttribute('aria-label') !== 'Close filters') close.setAttribute('aria-label','Close filters');
        if (!close.__fhBound){
          close.__fhBound = true;
          /* native <button> variant: browser already turns Enter/Space into click -> only remember keyboard mode */
          close.addEventListener('keydown', function(e){ if (isAct(e)){ DRAWER_KBD = true; if (nativeBtn(close)) return; e.preventDefault(); toggleCanvas(); setTimeout(syncDrawer, 30); } });
          /* NOTE: mouse/touch on the X is left exactly as Globo ships it (see optional FH-A11Y-2026-09-25-OPTIONAL-X-TAP snippet). */
        }
      }
      if (!isMobileDrawer() && tr.hasAttribute('inert')) tr.removeAttribute('inert');     /* desktop sidebar: never inert; mobile handled in syncDrawer */
    }
    if (tg){
      if (!nativeBtn(tg) && tg.getAttribute('role') !== 'button') tg.setAttribute('role','button');
      if (tg.getAttribute('aria-controls') !== 'gf-tree') tg.setAttribute('aria-controls','gf-tree');
      var ex = String(drawerOpen());
      if (tg.getAttribute('aria-expanded') !== ex) tg.setAttribute('aria-expanded', ex);
      var ic = $('i.fa', tg); if (ic && ic.getAttribute('aria-hidden') !== 'true') ic.setAttribute('aria-hidden','true');
      if (!tg.__fhBound){
        tg.__fhBound = true;
        tg.addEventListener('keydown', function(e){ if (isAct(e)){ DRAWER_KBD = true; if (nativeBtn(tg)) return; e.preventDefault(); toggleCanvas(); setTimeout(syncDrawer, 30); } });
      }
    }
    syncDrawer();
  }
  function syncDrawer(){
    if (!isMobileDrawer()) return;
    var open = drawerOpen(); var tr = $('#gf-tree'); var tg = $('.gf-refine-toggle-mobile');
    if (tg && tg.getAttribute('aria-expanded') !== String(open)) tg.setAttribute('aria-expanded', String(open));
    if (tr.getAttribute('aria-hidden') !== String(!open)) tr.setAttribute('aria-hidden', String(!open));
    if (open){ if (tr.hasAttribute('inert')) tr.removeAttribute('inert'); } else if (!tr.hasAttribute('inert')) tr.setAttribute('inert','');
    if (LAST_DRAWER_OPEN === null){ LAST_DRAWER_OPEN = open; return; }
    if (open && !LAST_DRAWER_OPEN){
      if (DRAWER_KBD) setTimeout(function(){ var c = $('.gf-close-canvas', tr) || focusables(tr)[0]; if (c) try { c.focus({preventScroll:true}); } catch(e){ c.focus(); } }, 80);
    } else if (!open && LAST_DRAWER_OPEN){
      var ae = document.activeElement;
      /* return focus to the toggle only when the drawer was being used from the keyboard */
      if (DRAWER_KBD && tg && (!ae || ae === document.body || ae.tagName === 'MAIN' || (tr && tr.contains(ae)))) setTimeout(function(){ try { tg.focus({preventScroll:true}); } catch(e){ tg.focus(); } }, 30);
      DRAWER_KBD = false;
    }
    LAST_DRAWER_OPEN = open;
  }
  document.addEventListener('keydown', function(e){
    if (!drawerOpen()) return;
    var tr = $('#gf-tree');
    /* any keyboard use inside the open drawer counts as keyboard mode (focus is returned to the toggle on close) */
    if (e.key === 'Tab' || isAct(e)) DRAWER_KBD = true;
    /* Escape: same result as Globo's own keyup(Esc) handler (remove html.offcanvas-open), done on keydown so focus can be returned */
    if (e.key === 'Escape' || e.key === 'Esc'){ e.preventDefault(); DRAWER_KBD = true; document.documentElement.classList.remove('offcanvas-open'); tr.setAttribute('aria-hidden','true'); setTimeout(syncDrawer, 30); return; }
    if (e.key === 'Tab'){
      var f = focusables(tr); if (!f.length) return;
      var first = f[0], last = f[f.length-1], ae = document.activeElement;
      if (!tr.contains(ae)){ e.preventDefault(); first.focus(); }
      else if (e.shiftKey && ae === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && ae === last){ e.preventDefault(); first.focus(); }
    }
  }, true);

  /* ---------- 3) pagination ---------- */
  function pageInfo(){
    var wrap = $('#gf_pagination_wrap'); if (!wrap) return null;
    var cur = $('.page.current', wrap); var nums = $$('a, span.page', wrap).map(function(x){ return parseInt(txt(x).replace(/\D/g,''),10); }).filter(function(n){ return !isNaN(n); });
    return { cur: cur ? parseInt(txt(cur).replace(/\D/g,''),10) : null, max: nums.length ? Math.max.apply(null, nums) : null };
  }
  function fixPagination(){
    var wrap = $('#gf_pagination_wrap'); if (!wrap) return;
    /* single-page / empty results: Globo leaves an empty wrapper -> no landmark (remove ours if the list shrank) */
    if (!$('a, .page', wrap)){ if (wrap.getAttribute('data-fh-nav')){ wrap.removeAttribute('role'); wrap.removeAttribute('aria-label'); wrap.removeAttribute('data-fh-nav'); } return; }
    wrap.setAttribute('data-fh-nav','1');
    if (wrap.getAttribute('role') !== 'navigation') wrap.setAttribute('role','navigation');
    if (wrap.getAttribute('aria-label') !== 'Pagination') wrap.setAttribute('aria-label','Pagination');
    $$('.page.current', wrap).forEach(function(c){
      if (c.getAttribute('aria-current') !== 'page') c.setAttribute('aria-current','page');
      if (!$('.fh-a11y-sr', c)){ var s = document.createElement('span'); s.className = 'fh-a11y-sr'; s.textContent = 'Page '; c.insertBefore(s, c.firstChild); }
    });
    $$('.deco', wrap).forEach(function(d){ if (d.getAttribute('aria-hidden') !== 'true') d.setAttribute('aria-hidden','true'); });
    $$('a', wrap).forEach(function(a){
      var p = a.parentElement, n = txt(a), lab = null;
      if (p && p.classList.contains('next')) lab = 'Next page';
      else if (p && p.classList.contains('prev')) lab = 'Previous page';
      else if (/^\d+$/.test(n)) lab = 'Page ' + n;
      if (lab && a.getAttribute('aria-label') !== lab) a.setAttribute('aria-label', lab);
    });
  }
  /* any page change (mouse or keyboard) -> polite announcement only; focus move only for keyboard activation.
     Keyboard = Enter keydown on the link, or a synthetic click with detail 0 (Enter on a link). */
  document.addEventListener('keydown', function(e){ if (e.key === 'Enter' && e.target && e.target.closest && e.target.closest('#gf_pagination_wrap a')) PAGE_KBD = Date.now(); }, true);
  document.addEventListener('click', function(e){ var a = e.target && e.target.closest && e.target.closest('#gf_pagination_wrap a'); if (a){ PAGE_PENDING = Date.now(); if (!(PAGE_KBD && Date.now() - PAGE_KBD < 1000) && e.detail !== 0) PAGE_KBD = false; } }, true);
  function afterPageRender(){
    if (!PAGE_PENDING || Date.now() - PAGE_PENDING > 15000) return;
    var grid = $('#gf-products'); var pi = pageInfo();
    if (!grid || !pi || !pi.cur) return;
    if (grid.__fhLastPage === pi.cur) return;
    grid.__fhLastPage = pi.cur; PAGE_PENDING = false;
    if (PAGE_KBD){
      PAGE_KBD = false;
      /* temporary tabindex so mouse clicks on the grid never focus it; removed again on blur */
      if (!grid.hasAttribute('tabindex')){ grid.setAttribute('tabindex','-1'); grid.addEventListener('blur', function rm(){ grid.removeAttribute('tabindex'); grid.removeEventListener('blur', rm); }); }
      if (!grid.getAttribute('aria-label')) grid.setAttribute('aria-label','Products');
      try { grid.focus({preventScroll:true}); } catch(e){ grid.focus(); }
    }
    var n = $$('.spf-product-card', grid).length;
    announce('Page ' + pi.cur + (pi.max ? ' of ' + pi.max : '') + ' loaded. ' + n + (n === 1 ? ' product' : ' products') + ' shown.');
  }

  /* ---------- 4) list semantics ---------- */
  function fixList(){
    var ul = $('ul#gf-products'); if (!ul) return;
    Array.prototype.forEach.call(ul.children, function(c){ if (c.tagName === 'DIV' && c.getAttribute('role') !== 'listitem') c.setAttribute('role','listitem'); });
    if (!ul.__fhLastPage){ var pi = pageInfo(); if (pi && pi.cur) ul.__fhLastPage = pi.cur; }
  }

  function applyAll(){ try { style(); fixFacets(); fixDrawer(); fixPagination(); fixList(); afterPageRender(); } catch(err){ if (window.console) console.warn('FH-A11Y-2026-09-25', err); } }
  function schedule(){ clearTimeout(t); t = setTimeout(applyAll, 40); }
  var STARTED = false;
  function present(){ return !!(document.getElementById('gf-tree') || document.getElementById('gf-products') || document.getElementById('gf_pagination_wrap') || /spf-has-filter/.test(document.documentElement.className)); }
  function start(){
    /* graceful no-op on pages without Globo filter markup (home, PDP, cart...); re-check a few times in case Globo renders late */
    if (STARTED) return;
    if (!present()) return;
    STARTED = true;
    applyAll();
    [0,150,500,1500,3000,6000].forEach(function(ms){ setTimeout(applyAll, ms); });
    try {
      new MutationObserver(function(ms){ for (var i=0;i<ms.length;i++){ if (ms[i].type === 'childList' || ms[i].attributeName === 'aria-hidden' || ms[i].attributeName === 'class') { schedule(); return; } } })
        .observe(document.documentElement, { childList:true, subtree:true, attributes:true, attributeFilter:['aria-hidden','class'] });
    } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function(){ setTimeout(function(){ if (STARTED) applyAll(); else start(); }, 50); });
  [1500, 4000].forEach(function(ms){ setTimeout(start, ms); });
})();
/* FH-A11Y-2026-09-25 GLOBO FILTERS/PAGINATION END */
/* FH-A11Y-2026-09-25 GRID EMPTY ALT START */
/* Collection grid cards: decorative empty alt on product images (owner-approved 2026-09-25).
   Scope: collection pages only (/collections/<handle>, not /products/ URLs), Globo cards in #gf-products.
   Only imgs inside an image link that wave09 already demoted (data-ada-wave09="demoted", aria-hidden="true",
   no href) AND whose card has a separate, visible-to-AT named title link to the same product -> alt="".
   Catalog alts in Shopify are untouched; the original alt is kept in data-fh-alt-orig. ADA-only: no style/class/src change.
   Re-applies when wave09 demotes newly rendered Globo cards (filter/sort/pagination) via a debounced observer on
   childList + the data-ada-wave09 attribute only (no style observer). Idempotent.
   Reversible: delete everything between START and END markers. */
(function(){
  if (window.__fhGridEmptyAlt20260925) return; window.__fhGridEmptyAlt20260925 = true;
  var path = location.pathname || '';
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^\/]+\/?$/i.test(path)) return;   /* collection pages only */
  function norm(h){ try { var a = document.createElement('a'); a.href = h; return (a.pathname || '').replace(/\/$/, '').toLowerCase(); } catch(e){ return ''; } }
  function titleLink(card, target){
    var links = card.querySelectorAll('.spf-product-card__title a[href], a.spf-product-card__title[href]');
    for (var i = 0; i < links.length; i++){
      var a = links[i];
      if (a.closest('[aria-hidden="true"]')) continue;
      var name = (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim();
      if (name && norm(a.getAttribute('href')) === target) return a;
    }
    return null;
  }
  function apply(){
    try {
      var wraps = document.querySelectorAll('#gf-products .spf-product-card a.spf-product-card__image-wrapper[data-ada-wave09="demoted"][aria-hidden="true"]');
      for (var i = 0; i < wraps.length; i++){
        var w = wraps[i];
        if (w.hasAttribute('href')) continue;
        var card = w.closest('.spf-product-card');
        var target = norm(w.getAttribute('data-ada-href') || '');
        if (!card || !target || !titleLink(card, target)) continue;   /* never blank an img whose link has no other accessible name */
        var imgs = w.getElementsByTagName('img');
        for (var j = 0; j < imgs.length; j++){
          var img = imgs[j], alt = img.getAttribute('alt');
          if (alt === '') continue;
          if (alt !== null && !img.hasAttribute('data-fh-alt-orig')) img.setAttribute('data-fh-alt-orig', alt);
          img.setAttribute('alt', '');
        }
      }
    } catch(err){ if (window.console) console.warn('FH-A11Y-2026-09-25 grid-empty-alt', err); }
  }
  var t = null;
  function schedule(){ clearTimeout(t); t = setTimeout(apply, 60); }
  function start(){
    apply();
    [150, 500, 1500, 3000, 6000].forEach(function(ms){ setTimeout(apply, ms); });
    try {
      new MutationObserver(function(ms){
        for (var i = 0; i < ms.length; i++){
          if (ms[i].type === 'attributes' || (ms[i].addedNodes && ms[i].addedNodes.length)) { schedule(); return; }
        }
      }).observe(document.documentElement, { childList:true, subtree:true, attributes:true, attributeFilter:['data-ada-wave09'] });
    } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* FH-A11Y-2026-09-25 GRID EMPTY ALT END */
/* FH-A11Y-2026-09-25 GOOGLE BADGE FRAME TITLE START */
/*
 * axe `frame-title` / WAVE: Google Merchant Center "Store widget / Top Quality Store"
 * rating badge (merchantverse) — Google Customer Reviews badge code
 * (apis.google.com/js/platform.js?onload=renderBadge + gapi.ratingbadge.render) — is injected as
 *   <div id="___ratingbadge_N"><iframe id="I0_…" src="https://www.google.com/shopping/merchantverse/…"></iframe></div>
 * with no title/aria-label. Also covers Google's NEW store widget (gstatic merchantwidget.js →
 *   <div id="google-merchantwidget-iframe-wrapper"><iframe id="merchantwidgetiframe">), which is ALSO untitled.
 * The iframe element lives in OUR document, so we can name it.
 * Scope: only iframes whose src is google.com/shopping/merchantverse, id merchantwidgetiframe, or whose
 * parent id contains "ratingbadge" / is google-merchantwidget-iframe-wrapper. Never overwrites an existing title/aria-label (if Google adds one later,
 * this becomes a no-op). Does not touch anything inside the cross-origin frame.
 * Approved by Suchin 2026-09-25 12:39 ET (frame-title exception only; nothing inside Google's badge is touched;
 * nested-interactive inside the cross-origin iframe remains a vendor exception).
 * Source: Google Customer Reviews badge code in WishIt app embed "Custom script" (settings_data.json).
 * Reversible: delete this START..END block.
 */
(function fhGoogleStoreBadgeFrameTitle() {
  'use strict';
  var TITLE = 'Google Store Quality rating badge';
  var MAX_MS = 60000;

  function isBadgeFrame(f) {
    if (!f || f.tagName !== 'IFRAME') return false;
    var src = f.getAttribute('src') || '';
    var p = f.parentElement;
    return /\/\/www\.google\.com\/shopping\/merchantverse\//.test(src) ||
      f.id === 'merchantwidgetiframe' ||
      !!(p && p.id && (p.id.indexOf('ratingbadge') !== -1 || p.id === 'google-merchantwidget-iframe-wrapper'));
  }

  function nameFrames() {
    var frames = document.querySelectorAll('div[id*="ratingbadge"] iframe, #merchantwidgetiframe, #google-merchantwidget-iframe-wrapper iframe, iframe[src*="google.com/shopping/merchantverse"]');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      if (!isBadgeFrame(f)) continue;
      if (!f.getAttribute('title') && !f.getAttribute('aria-label') && !f.getAttribute('aria-labelledby')) {
        f.setAttribute('title', TITLE);
      }
    }
  }

  function start() {
    nameFrames();
    if (!('MutationObserver' in window) || !document.body) return;
    var bt = 0;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (!bt) bt = setTimeout(function () { bt = 0; nameFrames(); }, 100);
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); nameFrames(); }, MAX_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* FH-A11Y-2026-09-25 GOOGLE BADGE FRAME TITLE END */
/* FH-A11Y-2026-09-25 SORT KEYBOARD START */
/* Globo collection sort dropdown (label.sort-by-toggle + #globo-dropdown-sort_options) -> keyboard listbox (Suchin-approved 2026-09-25 14:27 ET).
   Reversible: delete everything between START and END markers (+ the SORT KEYBOARD CSS block in ada-a11y-overrides.css).
   Rule: ADA-only. No markup/visual change; mouse/touch path unchanged; focus moves only after keyboard input.
   - toggle: aria-haspopup=listbox, aria-controls; list: role=listbox + aria-label "Sort by"; spans: role=option, tabindex=-1, aria-selected
   - Enter/Space/ArrowDown on toggle: Globo's own keydown handler opens (.active/aria-expanded); we then focus the selected option
   - options: ArrowUp/Down/Home/End move, Enter/Space = option.click() (inline onclick -> changeSortBy), Escape closes + focus toggle, Tab closes
   - Globo CDN has a listbox keyboard module that wakes up once [role=option] exists. We handle option keys first (document capture)
     and stop propagation, so Globo's option handler never runs (its Enter path would overwrite the toggle's inner <span> with text).
     Globo's click handler also focuses the first option on mouse open once role=option exists -> we put focus back on the toggle
     for pointer clicks, so mouse behaviour stays exactly as before.
   Globo re-renders the toolbar: debounced MutationObserver + retries re-apply (idempotent). No-op without Globo sort markup. */
(function(){
  if (window.__fhA11ySortKbd20260925) return; window.__fhA11ySortKbd20260925 = true;
  var LIST_SEL = '#globo-dropdown-sort_options', OPT_SEL = '#globo-dropdown-sort_options [role="option"]';
  var KBD_RETURN_UNTIL = 0, t = null;
  function txt(el){ return (el && el.textContent || '').replace(/\s+/g,' ').trim(); }
  function setA(el, k, v){ if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function parts(from){
    var box = from ? from.closest('.sort-by') : document.querySelector('.sort-by');
    if (!box) return null;
    var tg = box.querySelector('.sort-by-toggle'), list = box.querySelector(LIST_SEL);
    if (!tg || !list) return null;
    return { box: box, tg: tg, list: list, opts: Array.prototype.slice.call(list.querySelectorAll('[data-sort]')) };
  }
  function currentSort(p){
    var cur = txt(p.tg.querySelector('span') || p.tg), hit = null;
    p.opts.forEach(function(o){ if (!hit && txt(o) === cur) hit = o; });
    if (!hit){ try { var q = new URLSearchParams(location.search).get('sort_by');
      if (q) p.opts.forEach(function(o){ if (!hit && o.getAttribute('data-sort') === q) hit = o; }); } catch(e){} }
    return hit;
  }
  function apply(){
    var p = parts(); if (!p) return;
    setA(p.tg, 'aria-haspopup', 'listbox'); setA(p.tg, 'aria-controls', p.list.id);
    setA(p.list, 'role', 'listbox'); setA(p.list, 'aria-label', 'Sort by');
    var sel = currentSort(p);
    p.opts.forEach(function(o){
      setA(o, 'role', 'option');
      if (o !== document.activeElement) setA(o, 'tabindex', '-1');
      setA(o, 'aria-selected', o === sel ? 'true' : 'false');
    });
    if (KBD_RETURN_UNTIL && Date.now() < KBD_RETURN_UNTIL){      /* keyboard selection: focus lost in Globo re-render -> back to toggle */
      var a = document.activeElement;
      if (!a || a === document.body || !document.contains(a)){ p.tg.focus(); KBD_RETURN_UNTIL = 0; }
    }
  }
  function isOpen(p){ return p.box.classList.contains('active') || p.tg.getAttribute('aria-expanded') === 'true'; }
  function open(p){ /* same state Globo's own open() writes; only used if Globo's handler did not already open */
    if (isOpen(p)) return; p.list.hidden = false; p.tg.setAttribute('aria-expanded','true'); p.box.classList.add('active');
  }
  function close(p){ /* mirrors Globo's close() */
    p.list.hidden = true; p.tg.setAttribute('aria-expanded','false'); p.box.classList.remove('active');
  }
  function focusOpt(p, i){
    if (!p.opts.length) return; i = Math.max(0, Math.min(p.opts.length - 1, i));
    p.opts.forEach(function(o, j){ o.setAttribute('tabindex', j === i ? '0' : '-1'); });
    p.opts[i].focus();
  }
  function focusSelected(p){ apply(); var s = currentSort(p); focusOpt(p, s ? p.opts.indexOf(s) : 0); }

  /* Toggle keys: let Globo's bubbling handler open (its own mechanism), then move focus to the selected option. */
  document.addEventListener('keydown', function(e){
    var tg = e.target && e.target.closest && e.target.closest('.sort-by-toggle'); if (!tg) return;
    var k = e.key; if (['Enter',' ','Spacebar','ArrowDown','ArrowUp'].indexOf(k) < 0) return;
    var p = parts(tg); if (!p) return;
    e.preventDefault();
    setTimeout(function(){ var q = parts(tg) || p; open(q); focusSelected(q); }, 0);
  }, true);

  /* Option keys: handled here (capture) and stopped, so Globo's option keydown handler does not double-handle. */
  document.addEventListener('keydown', function(e){
    var o = e.target && e.target.closest && e.target.closest(OPT_SEL); if (!o) return;
    var p = parts(o); if (!p) return;
    var i = p.opts.indexOf(o), k = e.key;
    if (k === 'ArrowDown'){ focusOpt(p, i + 1); }
    else if (k === 'ArrowUp'){ focusOpt(p, i - 1); }
    else if (k === 'Home' || k === 'PageUp'){ focusOpt(p, 0); }
    else if (k === 'End' || k === 'PageDown'){ focusOpt(p, p.opts.length - 1); }
    else if (k === 'Enter' || k === ' ' || k === 'Spacebar'){
      KBD_RETURN_UNTIL = Date.now() + 4000;
      o.click();                                  /* inline onclick -> Globo changeSortBy() (closes + reloads products) */
      p.tg.focus();
    }
    else if (k === 'Escape' || k === 'Esc'){ close(p); p.tg.focus(); }
    else if (k === 'Tab'){ close(p); e.stopPropagation(); return; }   /* no preventDefault: Tab moves on naturally */
    else return;
    e.preventDefault(); e.stopPropagation();
  }, true);

  /* Mouse/touch open: Globo focuses the first option once role=option exists; before this block focus stayed on the toggle. */
  document.addEventListener('click', function(e){
    var tg = e.target && e.target.closest && e.target.closest('.sort-by-toggle'); if (!tg || e.detail === 0) return;
    setTimeout(function(){ var a = document.activeElement;
      if (a && a.closest && a.closest(LIST_SEL) && document.contains(tg)) tg.focus({ preventScroll: true }); }, 0);
  }, true);

  function schedule(){ clearTimeout(t); t = setTimeout(apply, 80); }
  var STARTED = false;
  function wanted(){ var b = document.body; return !!b && (b.classList.contains('collection') || b.classList.contains('search') || !!document.querySelector('.sort-by-toggle, ' + LIST_SEL)); }
  function start(){
    /* Speed phase 1: only where Globo's sort dropdown can appear (collection/search pages, or once its markup exists). */
    if (STARTED || !wanted()) return;
    STARTED = true;
    apply(); [0, 250, 700, 1500, 3000, 6000].forEach(function(ms){ setTimeout(apply, ms); });
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true }); } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function(){ setTimeout(start, 1500); });
})();
/* FH-A11Y-2026-09-25 SORT KEYBOARD END */
/* FH-A11Y-2026-09-25 PDP SWATCH SEMANTICS START */
/*
 * PDP colour swatches (Dawn-derived <variant-radios>, theme section main-product,
 * .colorflexbox/.colorflexitembox markup + existing ada-swatch-keyboard.js/.css).
 * The swatches are ALREADY native <input type=radio name="Color"> (visually hidden,
 * focusable) with aria-label + <label for>. Native radios already give role=radio,
 * checked state, roving tab stop and Arrow (wrap) / Space behaviour, and the theme
 * already has a keyboard-only :focus-visible ring. So this block does NOT add ARIA
 * roles to the swatches (no duplicate semantics, no own Arrow handling = no
 * double-advance). It only:
 *   1. names the group: fieldset -> role=radiogroup + aria-label "<Option name>"
 *      (from the legend text before ":"), e.g. "Color" / "Colour";
 *   2. makes sure every swatch radio has a name (aria-label = value if missing);
 *   3. hides the duplicate visually-hidden text inside each label (aria-hidden) ONLY
 *      when the radio already has a non-empty aria-label, so the colour is not read twice;
 *   4. Enter on a swatch radio selects it (radio.click(), same path as mouse/Space)
 *      and prevents implicit submission of the product form (accidental Add to cart).
 * Idempotent; re-applied on shopify:section:load, variant change, and a debounced
 * MutationObserver scoped to <variant-radios> only. No CSS, no style changes.
 * Rollback: delete everything between START and END.
 */
(function () {
  if (window.__fhSwatchSemantics20260925) return;
  window.__fhSwatchSemantics20260925 = true;

  var RADIO_SEL = 'input[type="radio"]';

  function colorFieldsets(root) {
    var out = [];
    (root || document).querySelectorAll('variant-radios fieldset').forEach(function (fs) {
      if (fs.getAttribute('aria-hidden') === 'true') return;
      var isColor = fs.classList.contains('color') || fs.querySelector('.colorflexitembox, .ada-color-swatch-label') ||
        /^\s*colou?r\b/i.test((fs.querySelector('legend') || {}).textContent || '');
      if (isColor && fs.querySelector(RADIO_SEL)) out.push(fs);
    });
    return out;
  }

  function optionName(fs) {
    var lg = fs.querySelector('legend');
    var t = lg ? (lg.firstChild && lg.firstChild.nodeType === 3 ? lg.firstChild.textContent : lg.textContent) : '';
    t = (t || '').split(':')[0].replace(/\s+/g, ' ').trim();
    if (!t) { var r = fs.querySelector(RADIO_SEL); t = r && r.name ? r.name : 'Color'; }
    return t;
  }

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }

  function apply() {
    colorFieldsets().forEach(function (fs) {
      setAttr(fs, 'role', 'radiogroup');
      setAttr(fs, 'aria-label', optionName(fs));
      fs.querySelectorAll(RADIO_SEL).forEach(function (r) {
        var al = (r.getAttribute('aria-label') || '').trim();
        if (!al && r.value) { al = r.value; setAttr(r, 'aria-label', al); }
        if (!al || !r.id) return;
        var lab = fs.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(r.id) : r.id) + '"]');
        if (!lab) return;
        lab.querySelectorAll('.visually-hidden').forEach(function (s) {
          if (s.textContent.trim() === al) setAttr(s, 'aria-hidden', 'true');
        });
      });
    });
  }

  // Enter = select (same path as mouse/Space: native click -> change -> VariantRadios)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    var r = e.target;
    if (!r || !r.matches || !r.matches(RADIO_SEL)) return;
    var fs = r.closest('fieldset');
    if (!fs || colorFieldsets(fs.parentNode).indexOf(fs) < 0) return;
    e.preventDefault(); // block implicit form submission (Add to cart)
    if (!r.checked) r.click();
  }, true);

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  var observed = new WeakSet();
  function observe() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('variant-radios').forEach(function (vr) {
      if (observed.has(vr)) return; observed.add(vr);
      new MutationObserver(function (muts) {
        // ignore our own attribute writes: only react to structural changes
        for (var i = 0; i < muts.length; i++) if (muts[i].type === 'childList') { schedule(); return; }
      }).observe(vr, { childList: true, subtree: true });
      vr.addEventListener('change', schedule);
    });
  }
  function init() { apply(); observe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('variant:change', schedule);
})();
/* FH-A11Y-2026-09-25 PDP SWATCH SEMANTICS END */
/* FH-A11Y-2026-09-25 BLOG QUICKADD ARIA START */
/*
 * Hand-built product cards in the EComposer blog post template (element__code) reuse a copied Dawn quick-add button:
 * aria-labelledby="<button id> title-template--16868003381528__featured-collection-0-…" but the title id does not exist
 * (WAVE "Broken ARIA reference", ×5, and the 5 buttons share one id). Fix: only for .quick-add__submit whose
 * aria-labelledby points at a missing id -> drop aria-labelledby and set aria-label "<visible text> for <product name>"
 * (visible text stays first: label-in-name OK). Buttons with valid references (normal Dawn cards) are never touched.
 * Idempotent; runs on load + a few retries (cards are static HTML). No CSS, no visual change.
 * Rollback: delete START..END.
 */
(function () {
  if (window.__fhBlogQuickAddAria20260925) return; window.__fhBlogQuickAddAria20260925 = true;
  function fix() {
    document.querySelectorAll('.quick-add__submit[aria-labelledby]').forEach(function (b) {
      var ids = (b.getAttribute('aria-labelledby') || '').split(/\s+/).filter(Boolean);
      var broken = ids.some(function (i) { return !document.getElementById(i); });
      if (!broken) return;
      var visible = (b.textContent || '').replace(/\s+/g, ' ').trim() || 'Choose options';
      var card = b.closest('.product-card, .card-wrapper, li, .grid__item');
      var t = card && card.querySelector('.product-item-name, .card__heading, h3, h5');
      var pname = t ? (t.textContent || '').replace(/\s+/g, ' ').trim() : '';
      b.setAttribute('aria-label', pname ? visible + ' for ' + pname : visible);
      b.removeAttribute('aria-labelledby');
    });
  }
  function run() { fix(); [300, 1200, 3000].forEach(function (ms) { setTimeout(fix, ms); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', fix);
})();
/* FH-A11Y-2026-09-25 BLOG QUICKADD ARIA END */
/* FH-A11Y-2026-09-26 SEARCH PAGE: keep Globo pop-up off the search results page's own box so Tab reaches results. Rollback: delete this line and the next. */
(function () { var box = document.getElementById('Search-In-Template'); if (!box) return; box.classList.add('gf-ignore'); if (typeof window.customSearchSelectors !== 'string') { window.customSearchSelectors = 'form[action*=search] input[type=text]:not(.gf-controls-search-input):not(.gf-form-input):not(#gl-d-searchbox-input):not(.gf-ignore), form[action*=search] input[type=search]:not(.gf-controls-search-input):not(.gf-form-input):not(#gl-d-searchbox-input):not(.gf-ignore), input.search-input:not(#gl-d-searchbox-input):not(.gf-ignore), .search__input:not(#gl-d-searchbox-input):not(.gf-ignore), #text-search:not(.gf-controls-search-input):not(#gl-d-searchbox-input):not(.gf-ignore)'; } })();
/* FH-A11Y-2026-09-26 SEARCH CLOSE LABEL: Globo search pop-up close (x) button has no accessible name; label it until Globo fixes it. Rollback: delete this line and the next. */
(function () { function fix() { document.querySelectorAll('.gl-d-close-btn').forEach(function (b) { if (!b.getAttribute('aria-label') && !b.textContent.trim()) b.setAttribute('aria-label', 'Close search'); var s = b.querySelector('svg'); if (s) s.setAttribute('aria-hidden', 'true'); }); } var t = 0; new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = 0; fix(); }, 50); }).observe(document.documentElement, { childList: true, subtree: true }); fix(); })();